/* This example requires Tailwind CSS v2.0+ */
import { Fragment, useState, useEffect } from 'react'
import { Disclosure, Menu, Transition } from '@headlessui/react'
import { BellIcon, MenuIcon, XIcon, PlusIcon } from '@heroicons/react/outline'
import { appCollectionApi } from '@appmaker/core/api';
import useCollection from '@appmaker/core/hooks/useCollection';
import { Link, useHistory } from '@appmaker/core/routes';
// import {  } from "react-router-dom"
import { useAsyncFn } from 'react-use';
import coreApi from '@appmaker/core/api/core';
import { Helmet } from "react-helmet";
/* This example requires Tailwind CSS v2.0+ */
import { Listbox } from '@headlessui/react'
import { CheckIcon, SelectorIcon } from '@heroicons/react/solid'
import Loader from '@appmaker/components/Loading';
import DashboardLoading from 'components/skeltonLoading/Dashboard';
import { logoutUser } from './api';

const user = {
    name: 'Tom Cook',
    email: 'tom@example.com',
    imageUrl:
        'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80',
}
const navigation = [
    { name: 'Dashboard', href: '#', current: true },
    // { name: 'Team', href: '#', current: false },
    // { name: 'Projects', href: '#', current: false },
    // { name: 'Calendar', href: '#', current: false },
]

const onClickLogoutAction = async (props)=>{
    const returnUrl = await logoutUser()
    if(returnUrl && window.location && window.location.href){
        window.location.href = returnUrl
    }
}
const userNavigation = [
    // { name: 'Your Profile', href: '#' },
    // { name: 'Settings', href: '#' },
    { name: 'Sign out', href: '#', onClick: onClickLogoutAction },
]

const people = [
    { id: 30, name: 'Woocommerce' },
    { id: 40, name: 'Shopify' },
    { id: 32, name: 'Custom App' },
    { id: 29, name: 'Wordpress' },

]

function TemplateSelect({ onChange }) {
    const [selected, setSelected] = useState(people[0])
    useEffect(() => { onChange && onChange(selected) }, [selected])
    return (
        <Listbox value={selected} onChange={setSelected}>
            {({ open }) => (
                <>
                    <Listbox.Label className="block text-sm font-medium text-gray-700">Template</Listbox.Label>
                    <div className="mt-1 relative">
                        <Listbox.Button className="bg-white relative w-full border border-gray-300 rounded-md shadow-sm pl-3 pr-10 py-2 text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                            <span className="block truncate">{selected.name}</span>
                            <span className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
                                <SelectorIcon className="h-5 w-5 text-gray-400" aria-hidden="true" />
                            </span>
                        </Listbox.Button>

                        <Transition
                            show={open}
                            as={Fragment}
                            leave="transition ease-in duration-100"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <Listbox.Options className="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md py-1 text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm">
                                {people.map((person) => (
                                    <Listbox.Option
                                        key={person.id}
                                        className={({ active }) =>
                                            classNames(
                                                active ? 'text-white bg-indigo-600' : 'text-gray-900',
                                                'cursor-default select-none relative py-2 pl-3 pr-9'
                                            )
                                        }
                                        value={person}
                                    >
                                        {({ selected, active }) => (
                                            <>
                                                <span className={classNames(selected ? 'font-semibold' : 'font-normal', 'block truncate')}>
                                                    {person.name}
                                                </span>

                                                {selected ? (
                                                    <span
                                                        className={classNames(
                                                            active ? 'text-white' : 'text-indigo-600',
                                                            'absolute inset-y-0 right-0 flex items-center pr-4'
                                                        )}
                                                    >
                                                        <CheckIcon className="h-5 w-5" aria-hidden="true" />
                                                    </span>
                                                ) : null}
                                            </>
                                        )}
                                    </Listbox.Option>
                                ))}
                            </Listbox.Options>
                        </Transition>
                    </div>
                </>
            )}
        </Listbox>
    )
}

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

function NewApp() {
    let history = useHistory()
    const [appName, setAppName] = useState('')
    const [templateId, setTemplateId] = useState(30)
    const [saving, setSaving] = useState(false);
    console.log(templateId.id);
    const createApp = async (e) => {
        e.preventDefault()
        setSaving(true);
        // const resp = await appCollectionApi.create({ title: appName });
        try {
            const resp = await coreApi.createProject({
                name: appName,
                templateId: templateId.id
            })
            if (resp.status && resp.body) {
                setSaving(false)
                history.push(`${resp.body.id}/dashboard`)
            }
            console.log(resp);
        } catch (error) {

        }



    }

    return <div className="bg-white shadow sm:rounded-lg">
        <div className="px-4 py-5 sm:p-6">
            <h3 className="text-lg leading-6 font-medium text-gray-900">Create New App</h3>
            <div className="mt-2 max-w-xl text-sm text-gray-500">
                {/* <p>Change the email address you want associated with your account.</p> */}
            </div>
            <form className="mt-5 sm:flex sm:items-center">
                <div className="w-full sm:max-w-xs">
                    <label htmlFor="appName" className="sr-only">
                        AppName
                    </label>
                    <input
                        type="text"
                        name="appName"
                        id="appName"
                        onChange={e => setAppName(e.target.value)}
                        className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                        placeholder="App Name"
                    />
                    <TemplateSelect onChange={setTemplateId} />
                </div>
                <button
                    // disabled={!saving}
                    onClick={createApp}
                    type="submit"
                    className="mt-3 w-full inline-flex items-center justify-center px-4 py-2 border border-transparent shadow-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm"
                >
                    {saving ? 'Creating..' : 'Create'}
                </button>
            </form>
        </div>
    </div>

}

function MyApps() {

    const [{ value: items, loading }, doFetch] = useAsyncFn(coreApi.allProjects, []);
    useEffect(() => { doFetch() }, [])
    if(loading){
        return <Loader />
    }
    return (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
            {/* <NewApp /> */}
            {!loading && items && items.map((item) => (
                <div
                    key={item._id}
                    className="relative rounded-lg border border-gray-300 bg-white px-6 py-5 shadow-sm flex items-center space-x-3 hover:border-gray-400 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-indigo-500"
                >
                    <div className="flex-shrink-0">
                    </div>
                    <div className="flex-1 min-w-0">
                        <Link to={`/${item.id}/dashboard`} className="focus:outline-none">
                            <span className="absolute inset-0" aria-hidden="true" />
                            <p className="text-sm font-medium text-gray-900">{item.name}</p>
                            <p className="text-sm text-gray-500 truncate">{item.id}</p>
                        </Link>
                    </div>
                </div>
            ))}
        </div>
    )
}


export default function MyAppsDashBoard() {
    const [isLoading,setLoading] = useState(false);
    if(isLoading){
        return <DashboardLoading />
    }
    return (
        <div className="min-h-screen bg-white">
            <Helmet>
                <title>Dashboard - Appmaker.xyz</title>
            </Helmet>
            <Disclosure as="nav" className="bg-white border-b border-gray-200">
                {({ open }) => (
                    <>
                        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                            <div className="flex justify-between h-16">
                                <div className="flex">
                                    <div className="flex-shrink-0 flex items-center">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="150" height="40" viewBox="0 0 150 40" fill="none"><path d="M25.5505 8.51062H14.4267V27.3024H25.5505V8.51062Z" fill="#1A73EC"></path><path d="M33.7712 0H6.17336C4.53609 0 2.96587 0.651308 1.80814 1.81064C0.650406 2.96998 0 4.54238 0 6.18193V33.8181C0 35.4576 0.650406 37.03 1.80814 38.1894C2.96587 39.3487 4.53609 40 6.17336 40H33.7712C35.4085 40 36.9787 39.3487 38.1365 38.1894C39.2942 37.03 39.9446 35.4576 39.9446 33.8181V6.18193C39.9446 4.54238 39.2942 2.96998 38.1365 1.81064C36.9787 0.651308 35.4085 0 33.7712 0ZM28.5882 31.3689C28.5875 32.3143 28.212 33.2208 27.5441 33.8891C26.8763 34.5574 25.9708 34.9328 25.0266 34.9328H21.1567C21.6313 34.6555 22.0015 34.2294 22.2101 33.7202C22.4187 33.2111 22.454 32.6474 22.3105 32.1162C22.1671 31.585 21.853 31.1159 21.4166 30.7814C20.9803 30.4469 20.446 30.2656 19.8965 30.2656C19.347 30.2656 18.8128 30.4469 18.3764 30.7814C17.9401 31.1159 17.6259 31.585 17.4825 32.1162C17.3391 32.6474 17.3744 33.2111 17.5829 33.7202C17.7915 34.2294 18.1617 34.6555 18.6364 34.9328H14.9128C13.9682 34.9328 13.0623 34.557 12.3943 33.8882C11.7264 33.2193 11.3512 32.3121 11.3512 31.3662V8.63507C11.3512 7.68916 11.7264 6.782 12.3943 6.11314C13.0623 5.44428 13.9682 5.06852 14.9128 5.06852H25.0332C25.9778 5.06852 26.8837 5.44428 27.5516 6.11314C28.2195 6.782 28.5948 7.68916 28.5948 8.63507L28.5882 31.3689Z" fill="#1A73EC"></path><path d="M49.7286 22.3523C51.6502 22.3523 53.0988 21.6549 54.0745 20.2602V22.0167H56.1413V14.577C56.1413 14.0698 56.119 13.5962 56.0743 13.1562C56.0296 12.7162 55.9105 12.2985 55.7168 11.9032C55.3444 11.1052 54.756 10.5234 53.9516 10.158C53.1547 9.78505 52.2163 9.5986 51.1363 9.5986C49.7435 9.5986 48.6263 9.90439 47.7847 10.516C46.9431 11.1275 46.3771 11.9517 46.0866 12.9884L48.2651 13.6596C48.4737 12.9884 48.8423 12.5036 49.3711 12.2053C49.8999 11.9069 50.4809 11.7578 51.114 11.7578C52.0524 11.7578 52.7302 11.9591 53.1473 12.3619C53.5718 12.7572 53.8027 13.3725 53.8399 14.2078C52.8568 14.3421 51.896 14.4838 50.9576 14.6329C50.0191 14.7747 49.1998 14.9462 48.4997 15.1476C47.5687 15.4459 46.8612 15.8897 46.3771 16.4789C45.8929 17.0681 45.6509 17.8176 45.6509 18.7276C45.6509 19.3839 45.8036 19.988 46.1089 20.5399C46.4217 21.0844 46.8798 21.5244 47.4831 21.86C48.0938 22.1882 48.8423 22.3523 49.7286 22.3523ZM50.142 20.4392C49.3972 20.4392 48.8461 20.2677 48.4886 19.9246C48.1385 19.5815 47.9635 19.175 47.9635 18.7052C47.9635 18.2278 48.1199 17.8512 48.4327 17.5752C48.753 17.2993 49.1514 17.0793 49.6281 16.9152C50.1346 16.766 50.7304 16.6355 51.4156 16.5236C52.1083 16.4118 52.9089 16.2887 53.8176 16.1544C53.8101 16.4379 53.7915 16.7548 53.7617 17.1054C53.7319 17.4559 53.6686 17.7692 53.5718 18.0451C53.4824 18.4404 53.2925 18.8208 53.002 19.1862C52.719 19.5517 52.3354 19.8538 51.8513 20.0924C51.3746 20.3236 50.8049 20.4392 50.142 20.4392Z" fill="#18191F"></path><path d="M59.0312 27.3866H61.3773V21.1664C61.8019 21.5468 62.2897 21.8377 62.8408 22.039C63.3994 22.2479 64.0214 22.3523 64.7066 22.3523C65.8312 22.3523 66.7994 22.0726 67.6113 21.5132C68.4306 20.9464 69.0599 20.1819 69.4993 19.2198C69.9462 18.2577 70.1697 17.1725 70.1697 15.9643C70.1697 14.7485 69.9462 13.6634 69.4993 12.7087C69.0525 11.7466 68.4157 10.9896 67.5889 10.4377C66.7697 9.87828 65.794 9.5986 64.6619 9.5986C63.9171 9.5986 63.2468 9.72539 62.6509 9.97897C62.0551 10.2251 61.5412 10.5719 61.1092 11.0194V9.93422H59.0312V27.3866ZM64.3826 20.2379C63.2356 20.2379 62.4014 19.8388 61.8801 19.0408C61.3662 18.2428 61.1092 17.2172 61.1092 15.9643C61.1092 14.7113 61.3662 13.6895 61.8801 12.8989C62.394 12.1083 63.2021 11.713 64.3044 11.713C65.079 11.713 65.7158 11.9032 66.2148 12.2836C66.7138 12.664 67.0825 13.1748 67.3208 13.8163C67.5666 14.4577 67.6895 15.1737 67.6895 15.9643C67.6895 16.7623 67.5703 17.4857 67.332 18.1346C67.0936 18.776 66.7287 19.2869 66.2371 19.6673C65.753 20.0477 65.1348 20.2379 64.3826 20.2379Z" fill="#18191F"></path><path d="M72.6252 27.3866H74.9713V21.1664C75.3959 21.5468 75.8837 21.8377 76.4348 22.039C76.9934 22.2479 77.6154 22.3523 78.3006 22.3523C79.4252 22.3523 80.3934 22.0726 81.2053 21.5132C82.0246 20.9464 82.6539 20.1819 83.0933 19.2198C83.5402 18.2577 83.7637 17.1725 83.7637 15.9643C83.7637 14.7485 83.5402 13.6634 83.0933 12.7087C82.6465 11.7466 82.0097 10.9896 81.1829 10.4377C80.3637 9.87828 79.388 9.5986 78.2559 9.5986C77.5111 9.5986 76.8408 9.72539 76.2449 9.97897C75.6491 10.2251 75.1352 10.5719 74.7032 11.0194V9.93422H72.6252V27.3866ZM77.9766 20.2379C76.8296 20.2379 75.9954 19.8388 75.4741 19.0408C74.9602 18.2428 74.7032 17.2172 74.7032 15.9643C74.7032 14.7113 74.9602 13.6895 75.4741 12.8989C75.988 12.1083 76.7961 11.713 77.8984 11.713C78.673 11.713 79.3098 11.9032 79.8088 12.2836C80.3078 12.664 80.6765 13.1748 80.9148 13.8163C81.1606 14.4577 81.2835 15.1737 81.2835 15.9643C81.2835 16.7623 81.1643 17.4857 80.926 18.1346C80.6876 18.776 80.3227 19.2869 79.8311 19.6673C79.347 20.0477 78.7288 20.2379 77.9766 20.2379Z" fill="#18191F"></path><path d="M86.2192 22.0167H88.5653V14.4651C88.5653 13.6447 88.7888 12.9809 89.2356 12.4738C89.69 11.9666 90.2858 11.713 91.0232 11.713C91.7679 11.713 92.3601 11.9666 92.7995 12.4738C93.2464 12.9735 93.4698 13.6596 93.4698 14.5323L93.4586 22.0167H95.7936L95.8048 14.4651C95.8048 13.5552 96.0468 12.8691 96.5309 12.4066C97.0225 11.9442 97.5997 11.713 98.2626 11.713C98.9925 11.713 99.5809 11.9591 100.028 12.4514C100.475 12.9436 100.698 13.6223 100.698 14.4875L100.687 22.0167H103.022L103.033 13.9281C103.033 12.6304 102.672 11.59 101.949 10.8068C101.234 10.0237 100.229 9.63216 98.9329 9.63216C98.1434 9.63216 97.4284 9.80743 96.7879 10.158C96.1474 10.501 95.6409 10.9784 95.2685 11.59C94.9482 10.9784 94.4902 10.501 93.8943 10.158C93.306 9.80743 92.5947 9.63216 91.7605 9.63216C91.038 9.63216 90.3752 9.77759 89.7719 10.0685C89.1761 10.3519 88.6845 10.7397 88.2972 11.232V9.93422H86.2192V22.0167Z" fill="#18191F"></path><path d="M109.341 22.3523C111.263 22.3523 112.712 21.6549 113.687 20.2602V22.0167H115.754V14.577C115.754 14.0698 115.732 13.5962 115.687 13.1562C115.642 12.7162 115.523 12.2985 115.33 11.9032C114.957 11.1052 114.369 10.5234 113.564 10.158C112.768 9.78505 111.829 9.5986 110.749 9.5986C109.356 9.5986 108.239 9.90439 107.398 10.516C106.556 11.1275 105.99 11.9517 105.699 12.9884L107.878 13.6596C108.087 12.9884 108.455 12.5036 108.984 12.2053C109.513 11.9069 110.094 11.7578 110.727 11.7578C111.665 11.7578 112.343 11.9591 112.76 12.3619C113.185 12.7572 113.416 13.3725 113.453 14.2078C112.47 14.3421 111.509 14.4838 110.57 14.6329C109.632 14.7747 108.813 14.9462 108.113 15.1476C107.182 15.4459 106.474 15.8897 105.99 16.4789C105.506 17.0681 105.264 17.8176 105.264 18.7276C105.264 19.3839 105.416 19.988 105.722 20.5399C106.035 21.0844 106.493 21.5244 107.096 21.86C107.707 22.1882 108.455 22.3523 109.341 22.3523ZM109.755 20.4392C109.01 20.4392 108.459 20.2677 108.101 19.9246C107.751 19.5815 107.576 19.175 107.576 18.7052C107.576 18.2278 107.733 17.8512 108.046 17.5752C108.366 17.2993 108.764 17.0793 109.241 16.9152C109.747 16.766 110.343 16.6355 111.028 16.5236C111.721 16.4118 112.522 16.2887 113.43 16.1544C113.423 16.4379 113.404 16.7548 113.375 17.1054C113.345 17.4559 113.281 17.7692 113.185 18.0451C113.095 18.4404 112.905 18.8208 112.615 19.1862C112.332 19.5517 111.948 19.8538 111.464 20.0924C110.987 20.3236 110.418 20.4392 109.755 20.4392Z" fill="#18191F"></path><path d="M118.644 22.0167H121.024V16.1992L126.073 22.0167H129.246L123.727 15.9754L128.732 9.93422H125.761L121.024 15.7517V5.90674H118.655L118.644 22.0167Z" fill="#18191F"></path><path d="M135.506 22.3523C136.675 22.3523 137.737 22.0577 138.69 21.4685C139.643 20.8718 140.354 20.0328 140.824 18.9513L138.533 18.2241C137.923 19.5069 136.876 20.1484 135.394 20.1484C134.381 20.1484 133.584 19.8426 133.003 19.231C132.422 18.6194 132.084 17.7542 131.987 16.6355H140.98C141.062 15.1886 140.891 13.9393 140.466 12.8877C140.042 11.8361 139.397 11.0269 138.533 10.46C137.669 9.88574 136.623 9.5986 135.394 9.5986C134.217 9.5986 133.186 9.86337 132.3 10.3929C131.413 10.9224 130.721 11.672 130.222 12.6416C129.73 13.6112 129.484 14.756 129.484 16.0761C129.484 17.3217 129.734 18.418 130.233 19.3652C130.739 20.305 131.443 21.0396 132.344 21.5692C133.253 22.0912 134.307 22.3523 135.506 22.3523ZM135.484 11.6683C137.308 11.6683 138.344 12.7162 138.589 14.8119H132.043C132.192 13.7902 132.553 13.0108 133.126 12.4738C133.7 11.9368 134.485 11.6683 135.484 11.6683Z" fill="#18191F"></path><path d="M143.487 22.0167H145.844V15.9195C145.844 15.211 145.956 14.5546 146.179 13.9505C146.403 13.3464 146.797 12.8616 147.363 12.4961C147.766 12.2351 148.209 12.0822 148.693 12.0375C149.177 11.9927 149.613 12.0225 150 12.127V9.93422C149.456 9.8298 148.879 9.83353 148.268 9.94541C147.665 10.0573 147.136 10.281 146.682 10.6167C146.235 10.915 145.863 11.3289 145.565 11.8585V9.93422H143.487V22.0167Z" fill="#18191F"></path><path d="M133.956 31.9181H134.991V30.8819H133.956V31.9181Z" fill="#1A73EC"></path><path d="M135.831 31.9181H137.021L138.072 30.4204L139.115 31.9181H140.305L138.642 29.6275L140.263 27.3872H139.073L138.072 28.8346L137.054 27.3872H135.864L137.486 29.6275L135.831 31.9181Z" fill="#1A73EC"></path><path d="M141.568 33.9319H142.515L145.037 27.3872H144.027L142.8 30.6302L141.534 27.3872H140.483L142.314 31.8846L141.568 33.9319Z" fill="#1A73EC"></path><path d="M145.243 31.9181H149.11V31.0329H146.822L149.21 27.5298V27.3872H145.486V28.2724H147.639L145.243 31.7797V31.9181Z" fill="#1A73EC"></path></svg>
                                    </div>
                                    <div className="hidden sm:-my-px sm:ml-6 sm:flex sm:space-x-8">
                                        {navigation.map((item) => (
                                            <a
                                                key={item.name}
                                                href={item.href}
                                                className={classNames(
                                                    item.current
                                                        ? 'border-indigo-500 text-gray-900'
                                                        : 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700',
                                                    'inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium'
                                                )}
                                                aria-current={item.current ? 'page' : undefined}
                                            >
                                                {item.name}
                                            </a>
                                        ))}
                                    </div>
                                </div>
                                <div className="hidden sm:ml-6 sm:flex sm:items-center">
                                    <button className="bg-white p-1 rounded-full text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                        <span className="sr-only">View notifications</span>
                                        <BellIcon className="h-6 w-6" aria-hidden="true" />
                                    </button>

                                    {/* Profile dropdown */}
                                    <Menu as="div" className="ml-3 relative">
                                        {({ open }) => (
                                            <>
                                                <div>
                                                    <Menu.Button className="max-w-xs bg-white flex items-center text-sm rounded-full focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                                        <span className="sr-only">Open user menu</span>
                                                        <img className="h-8 w-8 rounded-full" src={user.imageUrl} alt="" />
                                                    </Menu.Button>
                                                </div>
                                                <Transition
                                                    show={open}
                                                    as={Fragment}
                                                    enter="transition ease-out duration-200"
                                                    enterFrom="transform opacity-0 scale-95"
                                                    enterTo="transform opacity-100 scale-100"
                                                    leave="transition ease-in duration-75"
                                                    leaveFrom="transform opacity-100 scale-100"
                                                    leaveTo="transform opacity-0 scale-95"
                                                >
                                                    <Menu.Items
                                                        static
                                                        className="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
                                                    >
                                                        {userNavigation.map((item) => (
                                                            <Menu.Item key={item.name}>
                                                                {({ active }) => (
                                                                    <button
                                                                        onClick={async ()=>{
                                                                            if(item?.onClick){
                                                                                setLoading(true);
                                                                                await item?.onClick(item)
                                                                                setLoading(false);
                                                                            }
                                                                        }}
                                                                        className={classNames(
                                                                            active ? 'bg-gray-100' : '',
                                                                            'block px-4 py-2 text-sm text-gray-700 w-full text-left hover:bg-gray-100'
                                                                        )}
                                                                    >
                                                                        {item.name}
                                                                    </button>
                                                                )}
                                                            </Menu.Item>
                                                        ))}
                                                    </Menu.Items>
                                                </Transition>
                                            </>
                                        )}
                                    </Menu>
                                </div>
                                <div className="-mr-2 flex items-center sm:hidden">
                                    {/* Mobile menu button */}
                                    <Disclosure.Button className="bg-white inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                        <span className="sr-only">Open main menu</span>
                                        {open ? (
                                            <XIcon className="block h-6 w-6" aria-hidden="true" />
                                        ) : (
                                            <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                                        )}
                                    </Disclosure.Button>
                                </div>
                            </div>
                        </div>

                        <Disclosure.Panel className="sm:hidden">
                            <div className="pt-2 pb-3 space-y-1">
                                {navigation.map((item) => (
                                    <a
                                        key={item.name}
                                        href={item.href}
                                        className={classNames(
                                            item.current
                                                ? 'bg-indigo-50 border-indigo-500 text-indigo-700'
                                                : 'border-transparent text-gray-600 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-800',
                                            'block pl-3 pr-4 py-2 border-l-4 text-base font-medium'
                                        )}
                                        aria-current={item.current ? 'page' : undefined}
                                    >
                                        {item.name}
                                    </a>
                                ))}
                            </div>
                            <div className="pt-4 pb-3 border-t border-gray-200">
                                <div className="flex items-center px-4">
                                    <div className="flex-shrink-0">
                                        <img className="h-10 w-10 rounded-full" src={user.imageUrl} alt="" />
                                    </div>
                                    <div className="ml-3">
                                        <div className="text-base font-medium text-gray-800">{user.name}</div>
                                        <div className="text-sm font-medium text-gray-500">{user.email}</div>
                                    </div>
                                    <button className="ml-auto bg-white flex-shrink-0 p-1 rounded-full text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                        <span className="sr-only">View notifications</span>
                                        <BellIcon className="h-6 w-6" aria-hidden="true" />
                                    </button>
                                </div>
                                <div className="mt-3 space-y-1">
                                    {userNavigation.map((item) => (
                                        <a
                                            key={item.name}
                                            href={item.href}
                                            className="block px-4 py-2 text-base font-medium text-gray-500 hover:text-gray-800 hover:bg-gray-100"
                                        >
                                            {item.name}
                                        </a>
                                    ))}
                                </div>
                            </div>
                        </Disclosure.Panel>
                    </>
                )}
            </Disclosure>

            <div className="py-10">
                <header>
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                        <h1 className="text-3xl font-bold leading-tight text-gray-900">Dashboard</h1>
                    </div>
                </header>
                <main>
                    <div className="max-w-7xl mx-auto sm:px-6 lg:px-8">
                        {/* Replace with your content */}
                        <div className="px-4 py-8 sm:px-0">
                            <MyApps />
                        </div>
                        {/* /End replace */}
                    </div>
                </main>
            </div>
        </div>
    )
}
